(function () {
  'use strict';

  /**
   * Reveals one stored secret to a SUPERADMIN (EDOCS-627). The server checks the role, the password and the reason,
   * and records every attempt in the audit log; the value is shown for VISIBLE_SECONDS and then wiped.
   */
  angular.module('eDocumentsApp').controller('SecretRevealController', SecretRevealController);

  SecretRevealController.$inject = ['$uibModalInstance', '$http', '$interval', '$scope', 'target'];

  var VISIBLE_SECONDS = 30;
  var MIN_REASON_LENGTH = 10;

  function SecretRevealController($uibModalInstance, $http, $interval, $scope, target) {
    var vm = this;
    var timer = null;

    vm.minReasonLength = MIN_REASON_LENGTH;
    vm.reason = '';
    vm.password = '';
    vm.value = null;
    vm.secondsLeft = 0;
    vm.errorKey = null;
    vm.copied = false;
    vm.isRevealing = false;

    vm.canSubmit = canSubmit;
    vm.submit = submit;
    vm.copy = copy;
    vm.close = close;

    $scope.$on('$destroy', wipe);

    function canSubmit() {
      return !vm.isRevealing && vm.password && vm.reason && vm.reason.trim().length >= MIN_REASON_LENGTH;
    }

    function submit() {
      if (!canSubmit()) {
        return;
      }
      vm.isRevealing = true;
      vm.errorKey = null;
      $http
        .post('api/secrets/reveal', { source: target.source, id: target.id, reason: vm.reason, password: vm.password })
        .then(
          function (response) {
            vm.password = '';
            vm.value = response.data.value;
            vm.secondsLeft = VISIBLE_SECONDS;
            timer = $interval(
              function () {
                vm.secondsLeft--;
                if (vm.secondsLeft <= 0) {
                  close();
                }
              },
              1000,
              VISIBLE_SECONDS
            );
          },
          function (response) {
            vm.password = '';
            var message = response && response.data && response.data.message;
            vm.errorKey = message && message.indexOf('error.') === 0 ? message.substring('error.'.length) : 'failed';
          }
        )
        .finally(function () {
          vm.isRevealing = false;
        });
    }

    function copy() {
      if (vm.value === null || !navigator.clipboard) {
        return;
      }
      navigator.clipboard.writeText(vm.value).then(function () {
        $scope.$apply(function () {
          vm.copied = true;
        });
      });
    }

    function wipe() {
      if (timer) {
        $interval.cancel(timer);
        timer = null;
      }
      vm.value = null;
      vm.password = '';
    }

    function close() {
      wipe();
      $uibModalInstance.dismiss('closed');
    }
  }
})();
